import $ from 'jquery';

// const containerEl = '.navc';
const listEl = '.navc__list';
const currentEl = '.navc__current';

/**
 * undefined, 1 - mouse click, mobile device tap
 * 13 - keyboard enter code
 * 32 - keyboard space code
 * @type {*[]}
 */
const keyCodesAvailable = [undefined, 1, 13, 32];

function navcOpen() {
  $(currentEl).addClass('open');
  $(listEl).slideDown();
}

function navcClose() {
  $(currentEl).removeClass('open');
  $(listEl).slideUp();
}

$(window).on('load resize', () => {
  $(currentEl).removeClass('open');
  $(listEl).removeAttr('style');
});

$(document).on('click tap keyup', currentEl, (event) => {
  if (keyCodesAvailable.indexOf(event.keyCode) === -1) {
    return;
  }

  if (!$(currentEl).hasClass('open')) {
    navcOpen();
  } else {
    navcClose();
  }
});
